import Component from '@glimmer/component';
import type { ComponentLike } from '@glint/template';

interface IconHeadingSignature {
  Args: {
    /** Decorative Phosphor icon rendered beside the heading content. */
    icon?: ComponentLike<{ Args: { size: number }; Element: SVGElement }>;
    /** Icon square size in CSS pixels. Defaults to the shared heading-icon size. */
    iconSize?: number;
    /** Semantic foreground class applied only to the icon. */
    iconClass?: string;
  };
  Blocks: {
    /** Heading content aligned to the icon's visual center. */
    default: [];
  };
  Element: HTMLDivElement;
}

/**
 * Shared icon-and-heading row used by page headers and hero headings. The
 * component keeps the SVG and heading in one centered line so supporting copy
 * below the row cannot pull the icon away from the title.
 */
export default class IconHeading extends Component<IconHeadingSignature> {
  get iconSize() {
    return this.args.iconSize ?? 24;
  }

  <template>
    <div data-test-icon-heading class="tio-row-tight min-w-0" ...attributes>
      {{#if @icon}}
        {{#let @icon as |Icon|}}
          <span
            data-test-icon-heading-icon
            class="tio-inline-row shrink-0 leading-none {{@iconClass}}"
            aria-hidden="true"
          >
            <Icon @size={{this.iconSize}} class={{if @iconSize undefined "tio-icon-default"}} />
          </span>
        {{/let}}
      {{/if}}
      {{yield}}
    </div>
  </template>
}

export type { IconHeadingSignature };
